import { Grid, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../LanguageContext';
import { useIntl } from 'react-intl';
import { getPrefix } from '../../global_func';
import useFetchFooter from '../../hooks/api/useFetchFooter';
import Skeleton from '../skeletons/Skeletons';
import useWindowSize from '../../hooks/useWindowResize';

const Footer = () => {
	const theme = useTheme();
	const { locale } = useLanguage();
	const intl = useIntl();

	const { width } = useWindowSize();

	const { data: footer, isLoading, error } = useFetchFooter();

	const linksList = [
		{ title: 'headerMainPage', link: '/' },
		{ title: 'headerNews', link: '/news' },
		{ title: 'headerServices', link: '/services' },
		{ title: 'headerAboutUs', link: '/about-us' },
		{ title: 'headerPrice', link: '/price' },
		{ title: 'headerConcatUs', link: '/contact-us' },
	];

	return (
		<Grid>
			<Grid
				container
				display={'grid'}
				gridTemplateColumns={{
					xs: '1fr',
					md: '1fr max-content 1fr',
				}}
				alignItems={'center'}
				justifyItems={'center'}
				columnGap={3}
				rowGap={6}
				bgcolor={theme.palette.secondary.one}
				px={{ md: '30px', lg: '103px' }}
				pt={'45px'}
				pb={'25px'}
			>
				<Grid
					display={'grid'}
					container
					columns={3}
					gridTemplateColumns={'max-content max-content max-content'}
					gap={'40px'}
					width={width > theme.breakpoints.values.md ? '100%' : 'max-content'}
				>
					{linksList.map(({ title, link }, index) => (
						<Link
							key={index}
							to={link}
						>
							<Typography
								style={{ cursor: 'pointer' }}
								color={'white'}
								fontSize={'16px'}
							>
								{intl.$t({ id: title })}
							</Typography>
						</Link>
					))}
				</Grid>
				<Grid>
					<img
						src={
							locale !== 'fa'
								? '/assets/Images/AltynLogo2.svg'
								: width > theme.breakpoints.values.md
								? '/assets/Images/YellowAltyn.svg'
								: '/assets/Images/AltynGroup.svg'
						}
						alt={'YellowAltyn'}
					/>
				</Grid>
				<Grid
					display={'flex'}
					flexDirection={'column'}
					alignItems={'end'}
					justifySelf={{ xs: 'center', md: 'end' }}
					gap={'40px'}
					px={{ xs: '10px', md: '0' }}
				>
					<Grid
						display={'flex'}
						alignItems={'center'}
						gap={'8px'}
						minWidth={'250px'}
					>
						{isLoading ? (
							<Skeleton />
						) : error ? (
							<Typography
								variant={'subtitle1'}
								color={'white'}
							>
								{error.message}
							</Typography>
						) : (
							<Typography
								variant={'subtitle1'}
								color={'white'}
								dangerouslySetInnerHTML={{
									__html: footer
										? footer['content_short' + getPrefix(locale)]
										: '',
								}}
							></Typography>
						)}
						<img
							src={'/assets/Images/locationIcon.svg'}
							alt={'location'}
						/>
					</Grid>
					<Grid
						display={'flex'}
						gap={5}
					>
						<Grid
							display={'flex'}
							alignItems={'center'}
							gap={'24px'}
						>
							<Grid
								display={'flex'}
								alignItems={'flex-start'}
								gap={'8px'}
							>
								<Typography
									variant={'subtitle1'}
									color={'white'}
								>
									<a
										href="http://instagram.com/_u/altyn.logistics/"
										target="_blank"
										rel="noreferrer"
										style={{
											color: 'white',
											fontSize: '16px',
										}}
									>
										altyn.logistics
									</a>
								</Typography>
								<img
									src={'/assets/Images/Instagram.svg'}
									alt={'Instagram'}
								/>
							</Grid>
						</Grid>
						<Grid
							display={'flex'}
							alignItems={'center'}
							gap={'8px'}
						>
							<Typography
								variant={'subtitle1'}
								fontWeight={500}
								color={'white'}
							>
								<a
									href="https://wa.me/+989025613535"
									target="_blank"
									rel="noreferrer"
									style={{
										color: 'white',
										fontSize: '16px',
									}}
								>
									{`${locale !== 'fa' ? '+' : ''}98-902-561-3535${
										locale === 'fa' ? '+' : ''
									}`}
								</a>
							</Typography>
							<img
								src={'/assets/Images/WhatsApp.svg'}
								alt={'WhatsApp'}
							/>
						</Grid>
					</Grid>
					<Grid
						display={'flex'}
						alignItems={'flex-start'}
						gap={'8px'}
					>
						<Typography
							variant={'subtitle1'}
							color={'white'}
						>
							<a
								href="mailto:info@altynlogistics.com"
								style={{
									color: 'white',
									fontSize: '16px',
								}}
								target="_blank"
								rel="noreferrer"
							>
								info@altynlogistics.com
							</a>
						</Typography>
						<img
							src={'/assets/Images/email.svg'}
							alt={'Email'}
						/>
					</Grid>
				</Grid>
			</Grid>
			<Grid
				display={'flex'}
				alignItems={'center'}
				justifyContent={'space-between'}
				flexDirection={width > theme.breakpoints.values.md ? 'row' : 'column'}
				bgcolor={theme.palette.info.four}
				px={width > theme.breakpoints.values.md ? { md: '30px', lg: '103px' } : 0}
				gap={width > theme.breakpoints.values.md ? 0 : '8px'}
				py={'19px'}
			>
				<Grid
					display={'flex'}
					flexDirection={'column'}
					alignItems={width > theme.breakpoints.values.md ? 'start' : 'center'}
					gap={'4px'}
				>
					<Typography
						variant={'h5'}
						color={'white'}
					>
						Altyn Group - 2023 Ⓒ Copyrigh
					</Typography>
					{isLoading ? (
						<Skeleton
							style={{
								height: '10px',
							}}
						/>
					) : error ? (
						<Typography
							variant={'subtitle1'}
							color={'white'}
						>
							{error.message}
						</Typography>
					) : (
						<Typography
							variant={'h5'}
							color={'white'}
							dangerouslySetInnerHTML={{
								__html: footer['content_short' + getPrefix(locale)],
							}}
						></Typography>
					)}
				</Grid>
				<Grid>
					<Typography
						variant={'h5'}
						color={'white'}
					>
						{intl.$t({ id: 'DesignBySubFooter' })}
					</Typography>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default Footer;
